

<template>
  <div class="px-4 py-3 list-item-component">
    <div class="vx-row md:px-4">
      <div class="vx-col md:w-3/4 w-1/2 items-center">
        <div class="flex items-center mb-1">
          <span class="text-primary mr-2">#{{data.nomor}}</span>
          <span class="">{{data.tanggal}}</span>
        </div>
        <div class="flex items-center">
          <h5 class="tranksaksi-title items-center mb-1">
            {{ data.task_title }}
          </h5>
          <div class="tranksaksi-tags ml-2 mt-1 flex">
            <vs-chip transparent v-for="(tag, index) in data.tags" :key="index" :color="pembelianLabelColor(tag)">
              {{ pembelianLabelText(tag) }}
            </vs-chip>
          </div>
        </div>
        <div class="flex items-center">
          <span>{{data.memo}}</span>
        </div>
      </div>

      <div class="vx-col md:w-1/4 w-1/2 flex items-center justify-end">
        <div class="flex items-center justify-end">
          <h5>{{formatTotal(data.task_total)}}</h5>
          <p class="truncate md:pl-6 pl-4">
            <span class="flex items-center rounded">
              <div class="h-3 w-3 rounded-full mr-2" :class="'bg-' + color(data.status_lunas)"></div>{{ status(data.status_lunas) }}
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      //data: this.$store.getters['pembelian/getTask'](this.tranksaksiId)
    }
  },
  computed: {
    pembelianLabelText () {
      return (text) => {
        const tags = this.$store.state.pembelian.tranksaksiTags
        return tags.find((tag) => {
          return tag.slug === text
        }).name
      }
    },
    pembelianLabelColor () {
      return (label) => {
        const tags = this.$store.state.pembelian.tranksaksiTags
        return tags.find((tag) => {
          return tag.slug === label
        }).color
      }
    }
  },
  methods: {
    formatTotal(value) {
      let val = (value/1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    color(val) {
      if (val === 'Lunas Sudah') {
        return 'success'
      } else if (val === 'Lunas Belum') {
        return 'danger'
      } 
    },
    status(val) {
      if (val === 'Lunas Sudah') {
        return 'Lunas'
      } else if (val === 'Lunas Belum') {
        return 'Belum'
      } 
    },
  }
}
</script>
